module.exports = __webpack_public_path__ + "static/21-1534596e759cd5f14bebb7e35c20d4f0.jpg";